<template>
   <div>

   </div>
</template>

<script>
   export default {
      data() {
         return {
            audioPlay: null,
            clickFlag: true,
            timer: null
         }
      },
      mounted() {
      },
      methods: {
         // 播放事件
         playMu(src) {
            if (this.clickFlag) {
               if (this.audioPlay != null) {
                  this.audioPlay.pause();
                  this.audioPlay = null;
               } else {
                  this.audioPlay = null;
                  this.audioPlay = new Audio(src)
                  this.audioPlay.loop = false
                  var bgmStatus = this.$store.state.musicPaused;
                  if (bgmStatus) {
                     if (window.WeixinJSBridge) {
                        document.addEventListener("WeixinJSBridgeReady", function () {
                           this.audioPlay.play();
                        }, false)
                        window.WeixinJSBridge.invoke("getNetworkType", {}, (res) => {
                           this.audioPlay.play();
                           this.audioPlay.onended = function () {
                              this.audioPlay.play();
                           };
                        });
                     } else {
                        this.audioPlay.play();
                        document.addEventListener("WeixinJSBridgeReady", () => {
                           window.WeixinJSBridge.invoke("getNetworkType", {}, (res) => {
                              this.audioPlay.play();
                           });
                        }, false);
                     }
                  }
               }

            }
            if (this.clickFlag == true) {
               this.clickFlag = false
               setTimeout(() => {
                  this.clickFlag = true
               },700)
            }
         },
         btn_pause() {
            let audioPlay = this.$refs.btn_audio;
            this.audioPlay.pause()
         }
      }
   }
</script>